<!--if the mat-menu isn't here, the mat-menu-items aren't styled nicely-->
<div role="toolbar">
  <a tabindex='-1' uiSref='{{item.RouteName}}' *ngFor='let item of (items$ | async)'><img [src]="'../images/' + item.ProcessResourceImage">  {{item.ProcessTitle}}</a>
  <button mat-button clicked="UserManualClicked()" tabindex='-1'>
    User Manual
  </button>
</div>
